import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Documents from "./components/documents";
import Skills from "./components/Skills";
import "./index.css";

const siteUrl = "https://nkushal.info.np";

const routeMetadata = {
  "/": {
    title: "Kushal Neupane (KUxH) | IT Engineer | Full Stack Developer | Portfolio",
    description:
      "Official portfolio of Kushal Neupane (KuxH), an IT Engineer specializing in Full Stack Development, System Administration, Linux, DevOps, QA, and modern web technologies.",
    keywords:
      "Kushal Neupane, KuxH, IT Engineer Nepal, Full Stack Developer, MERN Stack, React Developer, Node.js Developer, Linux Administrator, DevOps, QA Engineer, Nepal Portfolio",
  },
  "/about": {
    title: "About Kushal Neupane | IT Engineer & Full Stack Developer",
    description:
      "Learn about Kushal Neupane, an IT Engineer with experience in full stack development, Linux administration, QA, and production support.",
    keywords: "Kushal Neupane, KuxH, IT Engineer, Full Stack Developer, Linux Administration, QA Engineer, Nepal",
  },
  "/projects": {
    title: "Projects by Kushal Neupane | Full Stack Developer Portfolio",
    description:
      "Browse selected projects by Kushal Neupane showcasing full stack development, deployment, Linux systems, and modern web applications.",
    keywords: "Kushal Neupane projects, MERN projects, React projects, Node.js projects, portfolio",
  },
  "/contact": {
    title: "Contact Kushal Neupane | IT Engineer & Developer",
    description:
      "Contact Kushal Neupane for development, QA, Linux, DevOps, or technical support opportunities.",
    keywords: "contact Kushal Neupane, KuxH contact, IT Engineer Nepal, developer contact",
  },
  "/documents": {
    title: "Documents | Kushal Neupane Portfolio",
    description:
      "Access documents, resources, and professional materials from Kushal Neupane's portfolio.",
    keywords: "Kushal Neupane documents, portfolio documents, resume, resources",
  },
};

function Home() {
  return (
    <>
      <Hero />
      <Skills />
    </>
  );
}

function App() {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    const metadata = routeMetadata[pathname] || routeMetadata["/"];
    const canonicalUrl = `${siteUrl}${pathname === "/" ? "" : pathname}`;

    document.title = metadata.title;
    document.documentElement.lang = "en";

    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) descriptionTag.setAttribute("content", metadata.description);

    const keywordsTag = document.querySelector('meta[name="keywords"]');
    if (keywordsTag) keywordsTag.setAttribute("content", metadata.keywords);

    const canonicalTag = document.querySelector('link[rel="canonical"]');
    if (canonicalTag) canonicalTag.setAttribute("href", canonicalUrl);

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", metadata.title);

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) ogDescription.setAttribute("content", metadata.description);

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute("content", canonicalUrl);

    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute("content", metadata.title);

    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) twitterDescription.setAttribute("content", metadata.description);
  }, [location.pathname]);

  return (
    <div className="font-sans bg-gray-50 text-gray-800 min-h-screen flex flex-col">
      <header>
        <Navbar />
      </header>
      <main className="flex-grow" id="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/documents" element={<Documents />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
